import React, { useEffect } from "react";
import AOS from "aos";
import AnchorLink from "react-anchor-link-smooth-scroll";
import "./style.css";

const Scrollbar = () => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);
  return (
    <div className="col-lg-12">
      <div className="header-menu">
        <ul className="smothscroll" data-aos="fade-up">
          <li>
            <AnchorLink href="#scrool">
              <i className="ti-arrow-up"></i>
            </AnchorLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Scrollbar;
